module.exports = __webpack_public_path__ + "img/人口.13e1c02e.png";